import Translate from '../../common/functions/translate';
import { Lang } from "../enums";

export function clone(item) {
  return (
    // return cloned copy so that the item is passed by value instead of by reference
    JSON.parse(JSON.stringify(item))
  );
}

// export function getErrorMessage(error) {
//   if (error.response) {
//     return { message: `${error.response.status} ${error.response.statusText}` }
//   } else {
//     return { message: `${error.message}` }
//   }
// }

export function getErrorMessage(error) {
  if (error.response) {
    if (
      error.response.data &&
      error.response.data.Data &&
      error.response.data.Data.ErrorCode
    ) {
      return { message: Translate(`${error.response.data.Data.ErrorCode}`) };
    }

    if (
      error.response.data &&
      error.response.data.Data &&
      error.response.data.Data.Message
    ) {
      return { message: `${error.response.data.Data.Message}` };
    }

    if (error.response.data) {
      return { message: Translate(`${error.response.data}`) };
    }

    return { message: `${error.response.status} ${error.response.statusText}` };
  } else {
    return { message: `${error.message}` };
  }
}

export function getQueryParam(locationSearch: string, paramName: string) {
  const query = new URLSearchParams(locationSearch);
  return query.get(paramName);
}

export function fomatDateAsString(date: Date) {
  return date.getFullYear().toString() + '-' +
    (date.getMonth() < 9 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()) + '-' +
    (date.getDate() < 10 ? '0' + (date.getDate()).toString() : (date.getDate()).toString());
}

export function fomatDateTimeAsString(date: Date) {
  return date.getFullYear().toString() + '-' +
    (date.getMonth() < 9 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()) + '-' +
    (date.getDate() < 10 ? '0' + (date.getDate()).toString() : (date.getDate()).toString()) + " " +
    ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
}

export function formatBytes(bytes, decimals) {
  if (bytes == 0) return '0 Bytes';
  var k = 1024,
    dm = decimals <= 0 ? 0 : decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

//Groups array by objects property and returns object of arrays
export function groupByReturnObject(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}

//Groups array by objects property and returns array of arrays
export function groupByReturnArray(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, []);
}

// export function enumToDropdownArray(enumName) {
//   let enumAsArray: Array<{ value: number, label: string }> = [];
//   for (var n in enumName) {
//     if (typeof enumName[n] === 'number') {
//       enumAsArray.push({ value: +enumName[n], label: n });
//     }
//   }
//   return enumAsArray;
// }

export function enumToDropdownArray(enumName, withTranslation?: boolean) {
  let enumAsArray: Array<{ value: number, label: string }> = [];
  for (var n in enumName) {
    if (typeof enumName[n] === 'number') {
      enumAsArray.push({ value: +enumName[n], label: withTranslation ? Translate(n) : n });
    }
  }
  return enumAsArray;
}

export function getEnumLabel(id: number, enumName: any, withTranslation?: boolean) {
  let enumElement = Object
    .keys(enumName)
    .find(key => enumName[key] === id);

  if (withTranslation) {
    return Translate(enumElement);
  }
  else {
    return enumElement;
  }
}

export function getEnumKeys(enumName: any) {
  return Object.keys(enumName).filter(k => typeof enumName[k as any] === "number");
}

export function getLangId(lang: string) {
  switch (lang) {
    case 'bg':
      return Lang.bg;
    case 'en':
      return Lang.en;
  }
}

export function formatAlarmTime(alarmTime: any) {
  if (typeof alarmTime === 'string') {
    if (alarmTime.length > 8) {
      return fomatTimeWithoutSecondsAsString(new Date(alarmTime));
    } else {
      return fomatTimeStringWithoutSecondsAsString(alarmTime);
    }
  } else {
    return fomatTimeWithoutSecondsAsString(new Date(alarmTime));
  }
}

export function fomatTimeWithoutSecondsAsString(date: Date) {
  return ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
}

export function fomatTimeStringWithoutSecondsAsString(time: string) {
  return time.slice(0, 5);
}

export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}


